import { getCurrentCollectionId } from 'selectors/menu-collections/getCurrentCollectionId'
import { getMenuMeta } from 'selectors/menu-metadata/getMenuMeta'
import { isRecipeLoaded } from 'selectors/menu-recipes/isRecipeLoaded'

import { actionTypes } from '../../../actions/actionTypes'
import * as trackingKeys from '../../../actions/trackingKeys'

export const menuRecipeDetailVisibilityChange = (recipeUuid) => (dispatch, getState) => {
  const isLoaded = isRecipeLoaded(recipeUuid)(getState())
  if (recipeUuid && !isLoaded) {
    return
  }

  const showRecipeDetails = Boolean(recipeUuid)
  const { menuId } = getMenuMeta(getState())
  const currentCollectionId = getCurrentCollectionId(getState())

  dispatch({
    type: actionTypes.MENU_RECIPE_DETAIL_VISIBILITY_CHANGE,
    recipeUuid,
    trackingData: {
      actionType: trackingKeys.changeMenuRecipeDetailVisibility,
      menu_uuid: menuId,
      collection_id: currentCollectionId,
      recipeUuid,
      show: showRecipeDetails,
    },
  })
}

export const showDetailRecipe = (recipeUuid) => (dispatch, getState) => {
  const { boxSummaryShow } = getState()

  if (!boxSummaryShow.get('show')) {
    menuRecipeDetailVisibilityChange(recipeUuid)(dispatch, getState)
  }
}

export const initSelectedRecipeVariantAction = (selectedRecipeVariants) => ({
  type: actionTypes.MENU_RECIPE_VARIANT_INIT,
  payload: { selectedRecipeVariants },
})

export const selectRecipeVariantAction = (
  originalRecipeId,
  variantId,
  collectionId,
  variantOutOfStock,
  view = 'grid',
  close = true,
  hasSurcharge,
  recipeReference,
) => ({
  type: actionTypes.MENU_RECIPE_VARIANT_SELECTED,
  payload: {
    collectionId,
    originalRecipeId,
    variantId,
    close,
    recipeReference,
  },
  trackingData: {
    actionType: trackingKeys.selectRecipeVariant,
    recipe_id: originalRecipeId,
    recipe_variant_id: variantId,
    collection_id: collectionId,
    variant_out_of_stock: variantOutOfStock,
    view,
    has_surcharge: hasSurcharge,
  },
})

export const selectRecipeVariant =
  ({
    originalRecipeId,
    variant,
    collectionId,
    variantOutOfStock,
    view = 'grid',
    close = true,
    recipeReference,
  }) =>
  async (dispatch) => {
    const hasSurcharges = variant.surcharge !== null

    dispatch(
      selectRecipeVariantAction(
        originalRecipeId,
        variant.coreId,
        collectionId,
        variantOutOfStock,
        view,
        close,
        hasSurcharges,
        recipeReference,
      ),
    )
  }
